module.exports = __webpack_public_path__ + "static/img/productLogo.8f16939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/productLogo.png
// module id = 0eTt
// module chunks = 1